import React from 'react';
import { Expert } from '../section/MapSection';
import { useMapContext } from '../context/mapContext';
import { PractitionerCard } from './PractitionerCard';

interface Props {
  list: Expert[];
}

export const MapCardsDesktop = ({ list }: Props) => {
  const { setSelected, selected } = useMapContext();
  return (
    <>
      {list.map((item, index) => (
        <div key={`item-desktop-${index}`}>
          <PractitionerCard
            data={item}
            onClick={() => {
              setSelected(list[index]);
            }}
            darkMode={selected?.id === item.id}
          />
        </div>
      ))}
    </>
  );
};
